import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import smartcity from "../../../Assets/Projects/UI/Smartcity1.png";
import smartcity2 from "../../../Assets/Projects/UI/Smartcity2.png";
import smartcity3 from "../../../Assets/Projects/UI/Smartcity3.png";
import smartcity4 from "../../../Assets/Projects/UI/Smartcity4.png";
import smartcity5 from "../../../Assets/Projects/UI/Smartcity5.png";
import smartcity6 from "../../../Assets/Projects/UI/Smartcity6.png";

function SmartCity() {
  return (
    <ProjectDetailCard
      title="Medan Smart City UI/UX Design"
      image={smartcity}
      screenshots={[smartcity2, smartcity3, smartcity4]}
      description="
      Medan Smart City is a UI/UX design project created to provide a modern and user-friendly digital platform for the Medan City Government. The interface was designed using Figma with a Smart City concept, focusing on intuitive navigation, visual consistency, and accessibility across desktop and mobile devices. The project includes responsive website layouts, mobile application interfaces, and supporting pages that present public services, city information, digital governance, and news in a clean and engaging user experience.
      "
      technologies={[
        "Figma",
        "UI Design",
        "UX Design",
        "Wireframing",
        "Prototyping",
        "Design System",
        "Responsive Design",
        "Mobile Design",
        "Desktop Design",
        "User Flow",
      ]}
      github=""
      demo=""
    >
      {/* Project Gallery */}
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={smartcity5} alt="gallery1" />
          <img src={smartcity6} alt="gallery2" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SmartCity;
